export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";